// extracted by mini-css-extract-plugin
module.exports = {"searchBoxWrapper":"YBD0i","searchBoxBackground":"_5ZDy8","searchBox":"_24wdZ"};